import { Document, Font, Image, Page, StyleSheet, Text, View, pdf, Link } from '@react-pdf/renderer'
import { useState } from 'react'
import { HiArrowDownTray } from 'react-icons/hi2'
import EuclidBold from '../../Styles/pdfFonts/euclidBold.ttf'
import EuclidItalic from '../../Styles/pdfFonts/euclidItalic.ttf'
import EuclidRegular from '../../Styles/pdfFonts/euclidRegular.ttf'
import EuclidMedium from '../../Styles/pdfFonts/euclidMedium.ttf'
import NotoSansRegular from '../../Styles/pdfFonts/notoSansRegular.ttf'
import { Spinner } from 'react-bootstrap'

const PDFDocument = ({ userData, employeeName, content, pdfLanguage }) => (
	<Document>
		<Page style={[styles.page, { padding: 0 }]}>
			<View style={{ width: '100%', height: '100%', padding: 0, margin: 0 }}>
				<Image src='https://assets.mydna.company/assessment-center-cover-pdf.png' cache style={{ height: '110%' }} />
				<View style={styles.roundedBox}>
					<Text style={styles.title}>
						Plan de{'\n'}
						Entrenamiento y{'\n'}
						Desarrollo
					</Text>
					<Text style={styles.name}>{employeeName}</Text>
					<Text style={styles.description}>
						Este reporte es un producto de MyDNA. MyDNA Assessment es una solución de liderazgo para todos para promover, atraer y retener talentos.
					</Text>
					<Text style={styles.footer}>2022 | C Todos los derechos reservados.</Text>
				</View>
			</View>
		</Page>

		<Page style={[styles.page, { padding: 0 }]}>
			<Image src='https://assets.mydna.company/pdf-sucession-plan/Mandalas.jpg' cache style={{ height: '110%' }} />
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Introducción: Guía de Desarrollo</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={[styles.defaultTextNotoSans, { fontSize: 9 }]}>
					El modelo de competencias de MyDNA proporciona una base sólida para el autoconocimiento, permitiendo identificar fortalezas y áreas de
					mejora a través de la evaluación de 20 competencias clave que caracterizan a una persona integral. En esta guía, partimos de los resultados
					de tu autoevaluación para ofrecerte un camino claro y personalizado hacia el desarrollo continuo.
				</Text>
				<Text style={[styles.defaultTextNotoSans, { fontSize: 9 }]}>
					El propósito de este documento es ayudarte a centrarte en las cinco competencias que obtuvieron las puntuaciones más bajas en tu evaluación.
					Estas representan tus principales oportunidades de mejora y, por ello, hemos diseñado este Guía de Desarrollo orientada a perfeccionarlas.
				</Text>
				<Text style={[styles.defaultTextNotoSans, { fontSize: 9 }]}>
					Cada sección de esta guía ofrece recomendaciones prácticas y estrategias específicas para trabajar en los comportamientos asociados a estas
					competencias, basándonos en estándares elevados de efectividad y tomando en cuenta que todos podemos evolucionar profesional y
					personalmente.
				</Text>
				<Text style={[styles.defaultTextNotoSans, { fontSize: 9 }]}>
					Te invitamos a dedicar tiempo y esfuerzo a este material, viendo cada desafío como una oportunidad para crecer. Al fortalecer estas
					competencias, podrás potenciar tu liderazgo, mejorar tus relaciones y avanzar hacia una versión más completa y armónica de ti mismo.
				</Text>
				<Text style={[styles.defaultTextNotoSans, { fontSize: 9 }]}>
					Estamos convencidos de que este proceso te ayudará a alcanzar mayor bienestar y efectividad en todos los aspectos de tu vida. ¡Comencemos
					juntos este viaje de desarrollo!
				</Text>

				<Text style={[styles.defaultText, { fontWeight: 'bold', marginTop: 20 }]}>Plan de Entrenamiento y Desarrollo</Text>
				<View style={{ marginRight: 26 }}>
					{userData.map((competence, index) => (
						<>
							<Link src={`#Competence-${index}`} style={{ textDecoration: 'none' }}>
								<View key={index} style={[styles.rectangleBox, { marginTop: 10 }]}>
									<Text style={[styles.defaultText, { lineHeight: 0, margin: 0, padding: 5, textDecoration: 'none' }]}>{competence.title}</Text>
									<Text style={[styles.defaultText, { lineHeight: 0, margin: 0, padding: 5, fontSize: 9, color: '#324154', opacity: 80 }]}>
										Página {index + 4}
									</Text>
									<View style={[styles.shadow]} />
								</View>
							</Link>
						</>
					))}
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		{userData.map((competence, index) => (
			<>
				<Page key={index} style={styles.page} id={`Competence-${index}`}>
					<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
						<Text style={styles.text}>{competence.title}</Text>
					</View>

					<View style={{ position: 'absolute', marginTop: 80 }}>
						<View style={[styles.rectangleContent, { marginLeft: 26 }]}>
							<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>Sobre</Text>

							<Text style={[styles.defaultTextContentNotoSans, { fontSize: 9 }]}>{competence.description}</Text>
							<View style={[styles.pillContainer]}>
								<Text style={[styles.pillEuclidMedium, { marginLeft: 10 }]}>Niveles Jerárquicos</Text>
								<Text
									style={[
										styles.defaultTextContentNotoSans,
										{
											fontSize: 9,
											marginBottom: 0,
											marginLeft: 3,
											maxWidth: 400,
											whiteSpace: 'normal',
										},
									]}
								>
									{competence.tags[0].desc}
								</Text>
							</View>
							<View style={[styles.pillContainer]}>
								<Text style={[styles.pillEuclidMedium, { marginLeft: 10, backgroundColor: '#c8fcf4' }]}>Áreas</Text>
								<Text
									style={[styles.defaultTextContentNotoSans, { fontSize: 9, marginBottom: 0, marginLeft: 3, maxWidth: 400, whiteSpace: 'normal' }]}
								>
									{competence.tags[1].desc}
								</Text>
							</View>
						</View>

						<View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginLeft: 26, marginTop: 12 }}>
							<View style={[styles.rectangleContent, { width: '49%' }]}>
								<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>
									Indicadores que pueden sugerir que un empleado no tiene habilidades bien desarrolladas
								</Text>

								<Text style={[styles.defaultTextContentNotoSans, { marginBottom: 5, fontSize: 9 }]}>1 - {competence.indicators[0].title}</Text>
								<Text style={[styles.defaultTextContentNotoSans, { marginBottom: 5, fontSize: 9 }]}>2 - {competence.indicators[1].title}</Text>
								<Text style={[styles.defaultTextContentNotoSans, { marginBottom: 0, fontSize: 9 }]}>3 - {competence.indicators[2].title}</Text>
							</View>

							<View style={[styles.rectangleContent, { width: '49%' }]}>
								<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>
									Herramientas para desarrollar el {competence.title}
								</Text>
								<View>
									<Text style={[styles.defaultTextContent, { marginBottom: 0, fontWeight: 'bold' }]}>1 - {competence.tools[0].title}</Text>
									<Text style={[styles.defaultTextContentNotoSans, { color: '#465568', marginBottom: 3, fontSize: 9 }]}>
										{competence.tools[0].description}
									</Text>
								</View>

								<View>
									<Text style={[styles.defaultTextContent, { marginBottom: 0, fontWeight: 'bold' }]}>2 - {competence.tools[1].title}</Text>
									<Text style={[styles.defaultTextContentNotoSans, { color: '#465568', marginBottom: 3, fontSize: 9 }]}>
										{competence.tools[1].description}
									</Text>
								</View>

								<View>
									<Text style={[styles.defaultTextContent, { marginBottom: 0, fontWeight: 'bold' }]}>3 - {competence.tools[2].title}</Text>
									<Text style={[styles.defaultTextContentNotoSans, { color: '#465568', marginBottom: 0, fontSize: 9 }]}>
										{competence.tools[2].description}
									</Text>
								</View>
							</View>
						</View>

						<View style={[styles.rectangleContent, { marginLeft: 26, marginTop: 12 }]}>
							<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>Desafíos Diarios</Text>
							<View>
								<Text style={[styles.defaultTextContent, { marginBottom: 0, fontWeight: 'bold' }]}>1 - {competence.dailyChallenges[0].title}</Text>
								<Text style={[styles.defaultTextContentNotoSans, { color: '#465568', marginBottom: 3, fontSize: 9 }]}>
									{competence.dailyChallenges[0].description}
								</Text>
							</View>
							<View>
								<Text style={[styles.defaultTextContent, { marginBottom: 0, fontWeight: 'bold' }]}>2 - {competence.dailyChallenges[1].title}</Text>
								<Text style={[styles.defaultTextContentNotoSans, { color: '#465568', marginBottom: 3, fontSize: 9 }]}>
									{competence.dailyChallenges[1].description}
								</Text>
							</View>
						</View>

						<View style={[styles.rectangleContent, { marginLeft: 26, marginTop: 12 }]}>
							<View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
								<View style={{ width: '50%', borderRight: '1px solid #d0d4e4' }}>
									<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>Libros</Text>
									{content[index].assessmentSkills.content[0].books.map((book, bookIndex) => (
										<Text key={bookIndex} style={[styles.defaultTextContentNotoSans, { marginBottom: 1, fontSize: 9 }]}>
											- {book}
										</Text>
									))}
								</View>
								<View style={{ width: '50%' }}>
									<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11 }]}>Películas/Series</Text>
									{content[index].assessmentSkills.content[0].movies.map((movie, movieIndex) => (
										<Text key={movieIndex} style={[styles.defaultTextContentNotoSans, { marginBottom: 1, fontSize: 9 }]}>
											- {movie}
										</Text>
									))}
								</View>
							</View>
							<View
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									marginBottom: 0,
									borderTop: '1px solid #d0d4e4',
								}}
							>
								<View style={{ width: '50%', borderRight: '1px solid #d0d4e4' }}>
									<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11, marginTop: 10 }]}>Vídeos</Text>
									{content[index].assessmentSkills.content[0].videos[pdfLanguage].map((video, videoIndex) => (
										<Link
											key={videoIndex}
											src={video.url}
											style={[styles.defaultTextContentNotoSans, { marginBottom: 2, color: '#7c6cec', textDecoration: 'underline', fontSize: 9 }]}
										>
											- {video.title}
										</Link>
									))}
								</View>
								<View style={{ width: '50%' }}>
									<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11, marginTop: 10 }]}>TED Talks</Text>
									{content[index].assessmentSkills.content[0].ted_talkings[pdfLanguage].map((ted, tedIndex) => (
										<Link
											key={tedIndex}
											src={ted.url}
											style={[styles.defaultTextContentNotoSans, { marginBottom: 2, color: '#7c6cec', textDecoration: 'underline', fontSize: 9 }]}
										>
											- {ted.title}
										</Link>
									))}
								</View>
							</View>
							<View>
								<View style={{ borderTop: '1px solid #d0d4e4' }}>
									<Text style={[styles.defaultTextContent, { fontWeight: 'bold', marginBottom: 2, fontSize: 11, marginTop: 10 }]}>Cursos</Text>
									{content[index].assessmentSkills.content[0].courses[pdfLanguage].map((course, courseIndex) => (
										<Link
											key={courseIndex}
											src={course.url}
											style={[styles.defaultTextContentNotoSans, { marginBottom: 2, color: '#7c6cec', textDecoration: 'underline', fontSize: 9 }]}
										>
											- {course.title}
										</Link>
									))}
								</View>
							</View>
						</View>
					</View>

					<View style={styles.footerPage}>
						<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

						<View style={styles.logoContainer}>
							<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
							<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
						</View>
					</View>
				</Page>
			</>
		))}

		<Page style={[styles.page, { padding: 0 }]}>
			<Link src='mailto:contacto@mydnadigital.com' style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
				<View style={{ position: 'absolute', backgroundColor: '#000', width: '100%', height: '20px', top: 0, left: 50 }} />
				<Image src='https://assets.mydna.company/pdf-assessment/closing-page-without-social.jpg' cache style={{ height: '100%' }} />
			</Link>
		</Page>
	</Document>
)

Font.register({
	family: 'Euclid Circular B',
	fonts: [
		{
			src: EuclidRegular,
			fontWeight: 'normal',
		},
		{
			src: EuclidBold,
			fontWeight: 'bold',
		},
		{
			src: EuclidItalic,
			fontStyle: 'italic',
		},
		{
			src: EuclidMedium,
			fontStyle: 500,
		},
	],
})

Font.register({
	family: 'Noto Sans',
	fonts: [
		{
			src: NotoSansRegular,
			fontWeight: 'normal',
		},
	],
})

const styles = StyleSheet.create({
	page: {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		width: '100%',
		padding: 10,
	},
	backgroundImage: {
		position: 'absolute',
		width: '100%',
		height: '100%',
	},
	roundedBox: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: '80%',
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 20,
		padding: 20,
	},
	headerText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 12,
		marginBottom: 22,
		marginLeft: 10,
	},
	title: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontWeight: 900,
		fontSize: 42,
		marginBottom: 22,
		marginLeft: 10,
	},
	name: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 18,
		marginBottom: 22,
		marginLeft: 10,
	},
	description: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
		lineHeight: 1.5,
	},
	defaultText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		marginBottom: 14,
		marginHorizontal: 26,
		lineHeight: 1.5,
	},
	defaultTextNotoSans: {
		fontFamily: 'Noto Sans',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		marginBottom: 14,
		marginHorizontal: 26,
		lineHeight: 1.5,
	},
	footer: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
	},

	rectangleContent: {
		border: '1px solid #d0d4e4',
		padding: 5,
		borderRadius: 5,
		backgroundColor: '#FFFFFF',
		width: 'auto',
		height: 'auto',
	},
	defaultTextContent: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		lineHeight: 1.5,
		marginHorizontal: 10,
		marginBottom: 6,
	},

	defaultTextContentNotoSans: {
		fontFamily: 'Noto Sans',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		lineHeight: 1.5,
		marginHorizontal: 10,
		marginBottom: 6,
	},

	rectangleBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		padding: 5,
		border: '1px solid #d0d4e4',
		borderColor: '#d0d4e4',
		backgroundColor: '#FFFFFF',
		borderRadius: 5,
		marginLeft: 26,
		marginRight: 26,
	},
	shadow: {
		position: 'absolute',
		bottom: -3,
		left: 0,
		width: '102%',
		height: 3,
		backgroundColor: 'rgba(208, 212, 228, 0.1)',
		borderRadius: 5,
	},

	pillContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 5,
	},
	pill: {
		fontSize: 9,
		paddingHorizontal: 8,
		paddingVertical: 4,
		backgroundColor: '#e0f4fc',
		borderRadius: 15,
		fontWeight: 'bold',
		color: '#2b2b2b',
		marginRight: 2,
	},
	pillEuclidMedium: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 500,
		fontSize: 9,
		paddingHorizontal: 8,
		paddingVertical: 4,
		backgroundColor: '#e0f4fc',
		borderRadius: 15,
		fontWeight: 'bold',
		color: '#2b2b2b',
		marginRight: 2,
	},

	circleNumber: {
		width: 14,
		height: 14,
		borderRadius: 10,
		backgroundColor: '#f5f8fc',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},

	//Tag for TitlePages
	roundedTextBox: {
		position: 'absolute',
		width: 'auto',
		// maxWidth: 350,
		left: 0,
		padding: 10,
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 35,
		borderBottomRightRadius: 35,
		marginBottom: 20,
	},
	text: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontSize: 18,
		marginLeft: 10,
		marginRight: 10,
		fontWeight: 700,
	},

	detailContainer: {
		position: 'absolute',
		bottom: 350,
		left: 20,
		flexDirection: 'row',
		alignItems: 'center',
	},

	//ContainerDimensions
	container: {
		marginLeft: 20,
		marginRight: 20,
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: '#0078D4',
		padding: 10,
		borderRadius: 10,
	},

	circleNumber: {
		width: 16,
		height: 16,
		borderRadius: 15,
		backgroundColor: '#f1f4f9',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: 10,
	},

	footerPage: {
		position: 'absolute',
		bottom: 10,
		left: 0,
		right: 0,
		height: 50,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingHorizontal: 30,
	},
	pageNumber: {
		fontSize: 10,
		color: '#000',
	},
	logoContainer: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	logo: {
		width: 60,
		height: 'auto',
	},

	containerOptions: {
		backgroundColor: '#f5f8fa',
		borderRadius: 10,
		padding: 10,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 5,
		marginBottom: 20,
		marginLeft: 20,
		marginRight: 20,
	},
	option: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	circle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		borderWidth: 1,
		borderColor: '#E69138',
		marginRight: 4,
	},
})

const PDFButtonDevelopmentGuide = ({ userData, employeeName, content, language }) => {
	const active = true
	const pdfLanguage = language === 'pt' ? 'pt_br' : 'es'
	const [loading, setLoading] = useState(false)

	const handleOpenPDF = async () => {
		setLoading(true)

		try {
			const doc = <PDFDocument userData={userData} employeeName={employeeName} content={content} pdfLanguage={pdfLanguage} />

			const asPdf = pdf([])
			asPdf.updateContainer(doc)

			const blob = await asPdf.toBlob()
			const url = URL.createObjectURL(blob)
			window.open(url, '_blank')
		} catch (error) {
			console.error('Erro ao gerar o PDF:', error)
		} finally {
			setLoading(false)
		}
	}

	return (
		<button
			onClick={handleOpenPDF}
			className={`tw-rounded-2xl tw-px-4 tw-py-2 tw-bg-white tw-flex tw-items-center tw-justify-center border tw-text-base tw-w-full ${
				active !== true ? 'tw-text-gray-300' : loading ? 'tw-text-purple-500' : 'tw-text-purple-500 hover:tw-bg-purple-500  hover:tw-text-white'
			}`}
			style={{ borderColor: '#7c6cec' }}
			disabled={active !== true || loading}
		>
			{loading ? (
				<Spinner animation='border' variant='primary' />
			) : (
				<>
					<HiArrowDownTray size={18} className='tw-mr-2' />
					<span>Descargar Plan</span>
				</>
			)}
		</button>
	)
}

export default PDFButtonDevelopmentGuide
